import React from 'react';
import styles from './NewsItem.module.scss';

const NewsItem = ({url, text, date, full_image_url, onOpenNews}) => {
  const isPreparedPreview = /\/preview-[^/]+\.png$/.test(url);
  const isLarge = text.length > 400;
  const previewText = text.length > 400 ? `${text.substr(0, 400)}...` : text.substr(0, 400);

  return (
    <div className={styles.newsItem}>
      <div className={styles.container}>
        <a className={styles.imageBlock} href={full_image_url}>
          <img className={`${styles.newsImage} ${isPreparedPreview ? styles.preparedPreview : ''}`} src={url} alt="news" />
        </a>
        <div className={styles.newsContent}>
          <div className={styles.newsTopBlock}>
            <div className={styles.newsInfoDate}><i>{date}</i></div>
            {isLarge ? (
              <div className={styles.newsControl} onClick={onOpenNews}>Показать</div>
              ) 
            : 
              <div></div>
            }
          </div>
          <div className={styles.newsInfoText} dangerouslySetInnerHTML={{ __html: previewText }}></div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(NewsItem);
